(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var lastCartOpener = null;

    function isFocusable(el) {
      if (!el || typeof el.focus !== 'function' || el === document.body) return false;
      if (!document.body.contains(el)) return false;
      if (el.disabled) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      var rects = el.getClientRects();
      if (!rects || rects.length === 0) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    function restoreCartFocus() {
      if (isFocusable(lastCartOpener)) {
        lastCartOpener.focus();
      } else {
        var fallback = document.querySelector('[data-cart-drawer-toggle], [data-cart-drawer-open], a[href*="/cart"]');
        if (isFocusable(fallback)) {
          fallback.focus();
        }
      }
      lastCartOpener = null;
    }

    window.openCartDrawer = function (opener) {
      if (opener && isFocusable(opener)) {
        lastCartOpener = opener;
      } else if (isFocusable(document.activeElement) && !drawer.contains(document.activeElement)) {
        lastCartOpener = document.activeElement;
      }
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      document.documentElement.classList.add('menu-open');
    };

    window.closeCartDrawer = function () {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
        document.documentElement.classList.remove('menu-open');
        restoreCartFocus();
      }
    };

    // Ensure menu-open scroll lock is cleanly removed when native dialog closes (e.g. via ESC key) and restore focus
    drawer.addEventListener('close', function () {
      document.documentElement.classList.remove('menu-open');
      restoreCartFocus();
    });

    drawer.addEventListener('cancel', function () {
      document.documentElement.classList.remove('menu-open');
    });

    // Close when clicking native dialog backdrop
    drawer.addEventListener('click', function (event) {
      if (event.target !== drawer) return;
      var rect = drawer.getBoundingClientRect();
      var isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!isInDialog) {
        window.closeCartDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-cart-drawer-close]');
      if (closeBtn) {
        window.closeCartDrawer();
      }

      var toggleBtn = event.target.closest('[data-cart-drawer-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        window.openCartDrawer(toggleBtn);
      }
    });


    // Complementary product upsell ("Complete the set")
    var upsell = drawer.querySelector('[data-cart-upsell]');
    var upsellList = drawer.querySelector('[data-cart-upsell-list]');
    var upsellFingerprint = null;

    function formatUpsellPrice(priceInCents) {
      var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var zeroDecimalCurrencies = ['BIF','CLP','DJF','GNF','ISK','JPY','KMF','KRW','PYG','RWF','UGX','VND','VUV','XAF','XOF','XPF'];
      var isZeroDecimal = zeroDecimalCurrencies.indexOf(activeCurrency.toUpperCase()) !== -1;
      var numericPrice = Number(priceInCents) || 0;
      var amount = isZeroDecimal ? numericPrice : (numericPrice / 100);
      try {
        return amount.toLocaleString(undefined, {
          style: 'currency',
          currency: activeCurrency
        });
      } catch (err) {
        if (activeCurrency === 'USD') return '$' + amount.toFixed(2);
        return isZeroDecimal ? (activeCurrency + ' ' + amount) : (activeCurrency + ' ' + amount.toFixed(2));
      }
    }

    function loadUpsell(cart) {
      if (!upsell || !upsellList) return Promise.resolve();
      if (!cart || !cart.items || !cart.items.length) {
        upsell.setAttribute('hidden', '');
        upsellFingerprint = null;
        return Promise.resolve();
      }
      var seed = cart.items[0].product_id;
      var inCart = cart.items.map(function (item) { return item.product_id; });
      var cartFingerprint = seed + ':' + inCart.slice().sort().join(',');
      if (cartFingerprint === upsellFingerprint && !upsell.hasAttribute('hidden')) return Promise.resolve();
      upsellFingerprint = cartFingerprint;

      var recsUrl = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products.json';
      return fetch(recsUrl + '?product_id=' + seed + '&limit=6&intent=complementary')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) {
          var picks = (data.products || []).filter(function (p) {
            return p && p.available && inCart.indexOf(p.id) === -1;
          }).slice(0, 2);

          upsellList.textContent = '';
          picks.forEach(function (p) {
            var variant = (p.variants || []).filter(function (v) { return v && v.available; })[0];
            if (!variant) return;
            var li = document.createElement('li');
            li.className = 'cart-drawer__upsell-item';

            if (p.featured_image) {
              var img = document.createElement('img');
              img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=112';
              img.alt = p.title || '';
              img.width = 56;
              img.height = 70;
              img.loading = 'lazy';
              li.appendChild(img);
            }

            var info = document.createElement('a');
            info.href = p.url;
            var name = document.createElement('span');
            name.className = 'cart-drawer__upsell-name';
            name.textContent = p.title;
            var price = document.createElement('span');
            price.className = 'cart-drawer__upsell-price';
            price.textContent = formatUpsellPrice(variant.price);
            info.appendChild(name);
            info.appendChild(price);
            li.appendChild(info);

            var add = document.createElement('button');
            add.type = 'button';
            add.className = 'btn small';
            add.textContent = upsell.getAttribute('data-label-add') || 'Add';
            add.addEventListener('click', function () {
              add.disabled = true;
              var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
              fetch(cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: variant.id, quantity: 1, sections: 'cart-drawer' })
              })
                .then(function (res) {
                  if (!res.ok) throw new Error('Failed to add upsell');
                  return res.json();
                })
                .then(function (data) {
                  if (data && data.sections && data.sections['cart-drawer']) {
                    applyDrawerSection(data.sections['cart-drawer']);
                    return window.refreshCartDrawer(true);
                  }
                  return window.refreshCartDrawer();
                })
                .catch(function (err) {
                  add.disabled = false;
                  console.error(err);
                });
            });
            li.appendChild(add);
            upsellList.appendChild(li);
          });

          if (upsellList.children.length) {
            upsell.removeAttribute('hidden');
          } else {
            upsell.setAttribute('hidden', '');
          }
        })
        .catch(function () {
          upsell.setAttribute('hidden', '');
        });
    }

    function applyDrawerSection(sectionHtml) {
      if (!sectionHtml) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHtml, 'text/html');
      var newContent = doc.querySelector('[data-cart-drawer-content]');
      var currentContent = drawer.querySelector('[data-cart-drawer-content]');
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }
      var newCount = doc.querySelector('[data-cart-drawer-count]');
      var currentCount = drawer.querySelector('[data-cart-drawer-count]');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }
    }
    window.applyCartDrawerSection = applyDrawerSection;

    var baseOpen = window.openCartDrawer;
    window.openCartDrawer = function (opener) {
      baseOpen(opener);
      var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      fetch(cartUrl).then(function (r) { return r.json(); }).then(loadUpsell).catch(function () {});
    };

    // Refresh cart drawer content using Section Rendering API
    window.refreshCartDrawer = function (skipHtml) {
      var busyEl = drawer.querySelector('[data-cart-drawer-content]');
      if (busyEl) {
        busyEl.classList.add('is-loading');
        busyEl.setAttribute('aria-busy', 'true');
      }
      var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      return fetch(cartUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch cart state');
          return res.json();
        })
        .then(function (cart) {
          loadUpsell(cart);
          // Update global cart count badges
          var countEls = document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]');
          countEls.forEach(function (el) {
            el.textContent = '[' + cart.item_count + ']';
          });
          if (skipHtml) return Promise.resolve();
          // Use Section Rendering API for lightweight payload
          var drawerBase = (window.routes && window.routes.cart_url) || '/cart';
          var drawerSectionUrl = new URL(drawerBase, window.location.origin);
          drawerSectionUrl.searchParams.set('section_id', 'cart-drawer');
          return fetch(drawerSectionUrl.toString(), { cache: 'no-store' })
            .then(function (res) {
              if (!res.ok) throw new Error('Failed to fetch updated drawer HTML');
              return res.text();
            })
            .then(function (html) {
              applyDrawerSection(html);
            });
        })
        .catch(function (err) {
          console.error('Cart drawer refresh failed:', err);
        })
        .then(function () {
          if (busyEl) {
            busyEl.classList.remove('is-loading');
            busyEl.removeAttribute('aria-busy');
          }
        });
    };

    // Handle quantity and remove clicks inside drawer
    drawer.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-key');
        var change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
        var currentQty = parseInt(qtyBtn.getAttribute('data-current-qty'), 10);
        var newQty = Math.max(0, currentQty + change);

        updateCartQuantity(key, newQty);
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var removeKey = removeBtn.getAttribute('data-key');
        updateCartQuantity(removeKey, 0);
      }
    });

    function updateCartQuantity(key, quantity) {
      drawer.style.pointerEvents = 'none';
      drawer.style.opacity = '0.7';

      var cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
      fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Failed to update quantity');
            });
          }
          return res.json();
        })
        .then(function (data) {
          if (data && data.sections && data.sections['cart-drawer']) {
            applyDrawerSection(data.sections['cart-drawer']);
            return window.refreshCartDrawer(true);
          }
          return window.refreshCartDrawer();
        })
        .catch(function (err) {
          console.error('Cart quantity update failed:', err);
        })
        .finally(function () {
          drawer.style.pointerEvents = '';
          drawer.style.opacity = '';
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var collectionAbortController = null;

    function renderSectionFromUrl(targetUrl, updateHistory) {
      var sectionContainer = document.querySelector('.collection-editorial[data-section-id]');
      if (!sectionContainer) {
        window.location.href = targetUrl;
        return;
      }
      var sectionId = sectionContainer.getAttribute('data-section-id');
      if (!sectionId) {
        window.location.href = targetUrl;
        return;
      }

      var fullTargetUrl = new URL(targetUrl, window.location.origin);
      var fetchUrl = new URL(fullTargetUrl.toString());
      fetchUrl.searchParams.set('section_id', sectionId);

      if (collectionAbortController) {
        collectionAbortController.abort();
      }
      collectionAbortController = new AbortController();
      var signal = collectionAbortController.signal;

      sectionContainer.style.opacity = '0.6';
      sectionContainer.style.pointerEvents = 'none';

      fetch(fetchUrl.toString(), { cache: 'no-store', signal: signal })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load collection section');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newSection = doc.querySelector('.collection-editorial[data-section-id="' + sectionId + '"]');
          if (!newSection) {
            newSection = doc.querySelector('.collection-editorial');
          }
          if (!newSection) {
            throw new Error('Section element not found in response');
          }

          sectionContainer.innerHTML = newSection.innerHTML;

          var currentDialog = document.querySelector('[data-filter-dialog]');
          var newDialog = doc.querySelector('[data-filter-dialog]');
          if (currentDialog && newDialog) {
            var currentBody = currentDialog.querySelector('.filter-drawer__body');
            var newBody = newDialog.querySelector('.filter-drawer__body');
            if (currentBody && newBody) currentBody.innerHTML = newBody.innerHTML;

            var currentFooter = currentDialog.querySelector('.filter-drawer__footer');
            var newFooter = newDialog.querySelector('.filter-drawer__footer');
            if (currentFooter && newFooter) currentFooter.innerHTML = newFooter.innerHTML;
          }

          if (updateHistory !== false && window.history && window.history.pushState) {
            window.history.pushState({ path: fullTargetUrl.toString() }, '', fullTargetUrl.toString());
          }

          initAll();
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.error('Section Rendering API error:', err);
          window.location.href = fullTargetUrl.toString();
        })
        .finally(function () {
          sectionContainer.style.opacity = '';
          sectionContainer.style.pointerEvents = '';
        });
    }

    function initCollectionSort(root) {
      if (!root) return;
      var select = root.querySelector ? root.querySelector('[data-sort-by]') : null;
      if (!select || select.dataset.sortInitialized) return;
      select.dataset.sortInitialized = 'true';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        renderSectionFromUrl(url.toString());
      });
    }

    function initCollectionFilters(root) {
      if (!root || !root.querySelector) return;
      var dialog = root.querySelector('[data-filter-dialog]');
      if (!dialog) return;

      var openButtons = root.querySelectorAll ? root.querySelectorAll('[data-filter-open]') : [];
      openButtons.forEach(function (btn) {
        if (btn.dataset.filterOpenInitialized) return;
        btn.dataset.filterOpenInitialized = 'true';
        btn.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.documentElement.classList.add('menu-open');
        });
      });

      function isFocusable(el) {
        if (!el || typeof el.focus !== 'function' || el === document.body) return false;
        if (!document.body.contains(el)) return false;
        if (el.disabled) return false;
        if (el.getAttribute('aria-hidden') === 'true') return false;
        var rects = el.getClientRects();
        if (!rects || rects.length === 0) return false;
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      function restoreFilterFocus() {
        var fallback = root.querySelector ? root.querySelector('[data-filter-open]') : null;
        if (!fallback) fallback = document.querySelector('[data-filter-open]');
        if (isFocusable(fallback)) {
          fallback.focus();
        }
      }

      function close() {
        if (typeof dialog.close === 'function') dialog.close();
        else {
          dialog.removeAttribute('open');
          document.documentElement.classList.remove('menu-open');
          restoreFilterFocus();
        }
      }

      if (!dialog.dataset.filterInitialized) {
        dialog.dataset.filterInitialized = 'true';

        dialog.addEventListener('click', function (e) {
          if (e.target === dialog || e.target.closest('[data-filter-close]')) close();
        });
        dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('menu-open');
          restoreFilterFocus();
        });
        dialog.addEventListener('cancel', function () {
          document.documentElement.classList.remove('menu-open');
        });
      }

      var form = dialog.querySelector('[data-filter-form]');
      if (form && !form.dataset.ajaxInitialized) {
        form.dataset.ajaxInitialized = 'true';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var formData = new FormData(form);
          var searchParams = new URLSearchParams();

          if (typeof formData.forEach === 'function') {
            formData.forEach(function (value, key) {
              if (value !== '') {
                searchParams.append(key, value);
              }
            });
          } else {
            var elements = form.elements;
            for (var i = 0; i < elements.length; i++) {
              var el = elements[i];
              if (!el.name || el.disabled) continue;
              if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
              if (el.value !== '') {
                searchParams.append(el.name, el.value);
              }
            }
          }

          var targetUrl = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
          targetUrl.search = searchParams.toString();
          close();
          renderSectionFromUrl(targetUrl.toString());
        });
      }
    }

    function initChipsAndPagination(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.collection-editorial__chip, .collection-editorial__pagination a, .filter-drawer__clear').forEach(function (link) {
        if (link.dataset.ajaxInitialized) return;
        link.dataset.ajaxInitialized = 'true';
        link.addEventListener('click', function (e) {
          if (link.href && !link.target && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
            var dialog = document.querySelector('[data-filter-dialog]');
            if (dialog) {
              if (typeof dialog.close === 'function' && dialog.open) {
                dialog.close();
              } else if (dialog.hasAttribute('open')) {
                dialog.removeAttribute('open');
                document.documentElement.classList.remove('menu-open');
              }
            }
            renderSectionFromUrl(link.href);
          }
        });
      });
    }

    function initAll() {
      initCollectionSort(document);
      initCollectionFilters(document);
      initChipsAndPagination(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('popstate', function () {
      renderSectionFromUrl(window.location.href, false);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-popup"]) return;
  try {
    
  (function () {
    var STORAGE_DISMISSED_KEY = 'alfadaa_drop_popup_dismissed_at';
    var STORAGE_SUBSCRIBED_KEY = 'alfadaa_drop_popup_subscribed';

    function initDropPopup() {
      var modal = document.querySelector('[data-drop-popup]');
      if (!modal || modal.dataset.popupInitialized) return;
      modal.dataset.popupInitialized = 'true';

      var isEnabled = modal.getAttribute('data-enabled') === 'true';
      var delaySeconds = parseInt(modal.getAttribute('data-delay'), 10);
      if (isNaN(delaySeconds) || delaySeconds < 0) delaySeconds = 5;
      var enableExitIntent = modal.getAttribute('data-exit-intent') === 'true';
      var cooldownDays = parseInt(modal.getAttribute('data-cooldown-days'), 10);
      if (isNaN(cooldownDays) || cooldownDays < 0) cooldownDays = 7;

      var hasTriggeredThisSession = false;
      var timerId = null;

      function isSuppressed() {
        try {
          if (localStorage.getItem(STORAGE_SUBSCRIBED_KEY) === 'true') return true;
          var dismissedAt = parseInt(localStorage.getItem(STORAGE_DISMISSED_KEY), 10);
          if (!isNaN(dismissedAt) && cooldownDays > 0) {
            var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
            if (Date.now() - dismissedAt < cooldownMs) return true;
          }
        } catch (e) {}
        return false;
      }

      function markDismissed() {
        try {
          localStorage.setItem(STORAGE_DISMISSED_KEY, String(Date.now()));
        } catch (e) {}
      }

      function markSubscribed() {
        try {
          localStorage.setItem(STORAGE_SUBSCRIBED_KEY, 'true');
        } catch (e) {}
      }

      function openPopup(force) {
        if (!modal) return;
        if (!force && (hasTriggeredThisSession || isSuppressed())) return;
        // Avoid opening on top of the predictive search modal if open
        var searchModal = document.getElementById('PredictiveSearchModal');
        if (!force && searchModal && searchModal.open) return;

        hasTriggeredThisSession = true;
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }

        if (typeof modal.showModal === 'function') {
          if (!modal.open) modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }

        var emailInput = modal.querySelector('[data-drop-popup-input]');
        if (emailInput) {
          setTimeout(function () { emailInput.focus(); }, 100);
        }
      }

      function closePopup() {
        if (!modal) return;
        markDismissed();
        if (typeof modal.close === 'function' && modal.open) {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }

      window.openDropPopup = function () {
        openPopup(true);
      };

      // Close button & backdrop click
      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('[data-drop-popup-close]')) {
          closePopup();
        }
      });

      modal.addEventListener('close', function () {
        markDismissed();
      });

      // Open manually from any #drop-access link or [data-drop-popup-open] button
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-drop-popup-open], a[href="#drop-access"]');
        if (trigger) {
          event.preventDefault();
          openPopup(true);
        }
      });

      // If the customer form was just posted or had errors, show immediately
      var postedState = modal.querySelector('[data-drop-popup-posted="true"]');
      var errorState = modal.querySelector('[data-drop-popup-errors="true"]');
      if (postedState) {
        markSubscribed();
        openPopup(true);
        return;
      }
      if (errorState) {
        openPopup(true);
        return;
      }

      // Automatic Timed & Exit-Intent triggers (only when enabled)
      if (isEnabled && !isSuppressed()) {
        timerId = setTimeout(function () {
          openPopup(false);
        }, delaySeconds * 1000);

        if (enableExitIntent) {
          document.addEventListener('mouseout', function onMouseOut(event) {
            if (hasTriggeredThisSession) {
              document.removeEventListener('mouseout', onMouseOut);
              return;
            }
            if (!event.relatedTarget && event.clientY <= 10) {
              openPopup(false);
              document.removeEventListener('mouseout', onMouseOut);
            }
          });
        }
      }

      // Shopify Theme Editor live preview events
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target && event.target.contains(modal)) {
          openPopup(true);
        }
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        if (event.target && event.target.contains(modal)) {
          closePopup();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDropPopup);
    } else {
      initDropPopup();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var posted = document.querySelector('[data-drop-signup-posted="true"]');
    if (posted) {
      try {
        localStorage.setItem('alfadaa_drop_popup_subscribed', 'true');
      } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-editorial"]) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (!header || header.dataset.headerInitialized) return;
      header.dataset.headerInitialized = 'true';

      var toggle = header.querySelector('[data-menu-toggle]');
      var drawer = document.getElementById('MobileDrawer');
      var searchModal = document.getElementById('PredictiveSearchModal');
      var searchInput = searchModal ? searchModal.querySelector('[data-search-input]') : null;
      var searchResults = searchModal ? searchModal.querySelector('[data-search-results]') : null;
      var searchClear = searchModal ? searchModal.querySelector('[data-search-clear]') : null;

      function setOpen(open) {
        if (!toggle || !drawer) return;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          open ? toggle.dataset.labelClose : toggle.dataset.labelOpen
        );
        drawer.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('menu-open', open);
      }

      if (toggle) {
        toggle.dataset.labelOpen = toggle.getAttribute('aria-label') || '';
        toggle.dataset.labelClose = toggle.getAttribute('data-label-close') || '';

        toggle.addEventListener('click', function () {
          setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        });
      }

      if (drawer) {
        drawer.addEventListener('click', function (event) {
          if (event.target.closest('[data-menu-close]')) setOpen(false);
        });
      }

      // Predictive Search Logic
      var searchOpener = null;

      function isFocusable(el) {
        if (!el || typeof el.focus !== 'function' || el === document.body) return false;
        if (!document.body.contains(el)) return false;
        if (el.disabled) return false;
        if (el.getAttribute('aria-hidden') === 'true') return false;
        var rects = el.getClientRects();
        if (!rects || rects.length === 0) return false;
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      function restoreSearchFocus() {
        if (isFocusable(searchOpener)) {
          searchOpener.focus();
        } else {
          var fallback = document.querySelector('[data-search-modal-open]');
          if (isFocusable(fallback)) {
            fallback.focus();
          }
        }
        searchOpener = null;
      }

      window.openSearchModal = function (opener) {
        if (!searchModal) return;
        if (opener && isFocusable(opener)) {
          searchOpener = opener;
        } else if (isFocusable(document.activeElement) && !searchModal.contains(document.activeElement)) {
          searchOpener = document.activeElement;
        }
        setOpen(false);
        if (typeof searchModal.showModal === 'function') {
          searchModal.showModal();
        } else {
          searchModal.setAttribute('open', '');
        }
        document.documentElement.classList.add('menu-open');
        if (searchInput) {
          setTimeout(function () { searchInput.focus(); }, 100);
        }
      };

      window.closeSearchModal = function () {
        if (!searchModal) return;
        if (typeof searchModal.close === 'function') {
          searchModal.close();
        } else {
          searchModal.removeAttribute('open');
          document.documentElement.classList.remove('menu-open');
          restoreSearchFocus();
        }
      };

      function escapeHtml(str) {
        if (str == null) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function sanitizeUrl(url) {
        if (!url) return '#';
        var clean = String(url).trim();
        if (/^javascript:/i.test(clean)) return '#';
        return clean.replace(/"/g, '&quot;');
      }

      document.addEventListener('click', function (event) {
        var openBtn = event.target.closest('[data-search-modal-open]');
        if (openBtn) {
          event.preventDefault();
          window.openSearchModal(openBtn);
        }
        if (event.target.closest('[data-search-modal-close]')) {
          window.closeSearchModal();
        }
      });

      if (searchModal && !searchModal.dataset.modalEventsInitialized) {
        searchModal.dataset.modalEventsInitialized = 'true';
        searchModal.addEventListener('click', function (event) {
          if (event.target === searchModal) window.closeSearchModal();
        });
        searchModal.addEventListener('close', function () {
          document.documentElement.classList.remove('menu-open');
          restoreSearchFocus();
        });
        searchModal.addEventListener('cancel', function () {
          document.documentElement.classList.remove('menu-open');
        });
      }

      // Keyboard shortcuts: '/' opens search, 'Escape' closes modal & drawer
      document.addEventListener('keydown', function (event) {
        if (event.key === '/' && searchModal && !searchModal.open) {
          var tag = (event.target.tagName || '').toLowerCase();
          if (tag !== 'input' && tag !== 'textarea' && tag !== 'select') {
            event.preventDefault();
            window.openSearchModal();
          }
        }
        if (event.key === 'Escape') {
          if (searchModal && searchModal.open) {
            window.closeSearchModal();
          } else if (drawer && drawer.classList.contains('is-open')) {
            setOpen(false);
            if (toggle) toggle.focus();
          }
        }
      });

      // Debounced Predictive Search Query with XSS escaping and AbortController
      var debounceTimer;
      var searchController = null;

      if (searchInput && searchResults) {
        var hintText = searchResults.getAttribute('data-hint') || 'Search the Archive';
        var termsPlaceholder = '{' + '{ terms }' + '}';
        var noResultsTemplate = searchResults.getAttribute('data-no-results') || ('No matching archive entries found for ' + termsPlaceholder + '.');
        var piecesTitle = searchResults.getAttribute('data-pieces') || 'Pieces';
        var storiesTitle = searchResults.getAttribute('data-stories') || 'Stories & Journal';
        var viewAllText = searchResults.getAttribute('data-view-all') || 'View all results &rarr;';
        var predictiveUrl = searchResults.getAttribute('data-predictive-url') || (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';
        var searchUrl = searchResults.getAttribute('data-search-url') || (window.routes && window.routes.search_url) || '/search';

        if (searchClear) {
          searchClear.addEventListener('click', function () {
            if (searchController) {
              searchController.abort();
              searchController = null;
            }
            searchInput.value = '';
            searchClear.hidden = true;
            searchResults.innerHTML = '<div class="search-modal__hint text-kicker">' + escapeHtml(hintText) + '</div>';
            searchInput.focus();
          });
        }

        searchInput.addEventListener('input', function () {
          var query = searchInput.value.trim();
          if (searchClear) searchClear.hidden = query.length === 0;

          clearTimeout(debounceTimer);
          if (searchController) {
            searchController.abort();
            searchController = null;
          }

          if (query.length < 2) {
            searchResults.innerHTML = '<div class="search-modal__hint text-kicker">' + escapeHtml(hintText) + '</div>';
            return;
          }

          debounceTimer = setTimeout(function () {
            searchController = new AbortController();
            var signal = searchController.signal;

            fetch(predictiveUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6', { signal: signal })
              .then(function (res) { return res.json(); })
              .then(function (data) {
                var products = (data.resources && data.resources.results && data.resources.results.products) || [];
                var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
                var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

                if (products.length === 0 && pages.length === 0 && articles.length === 0) {
                  var emptyMsg = noResultsTemplate.replace(termsPlaceholder, escapeHtml(query));
                  searchResults.innerHTML = '<div class="search-modal__hint text-kicker">' + emptyMsg + '</div>';
                  return;
                }

                var html = '';
                if (products.length > 0) {
                  html += '<div class="search-modal__group">';
                  html += '<h3 class="search-modal__group-title">' + escapeHtml(piecesTitle) + '</h3>';
                  html += '<div class="search-modal__grid">';
                  products.forEach(function (p) {
                    var pUrl = sanitizeUrl(p.url);
                    var pTitle = escapeHtml(p.title);
                    var pPrice = escapeHtml(p.price);
                    html += '<a href="' + pUrl + '" class="search-modal__item">';
                    if (p.image) {
                      html += '<img class="search-modal__thumb" src="' + sanitizeUrl(p.image) + '" alt="' + pTitle + '" width="48" height="60" loading="lazy">';
                    }
                    html += '<div class="search-modal__meta">';
                    html += '<span class="search-modal__title">' + pTitle + '</span>';
                    html += '<span class="search-modal__price">' + pPrice + '</span>';
                    html += '</div></a>';
                  });
                  html += '</div></div>';
                }

                var combinedStories = pages.concat(articles);
                if (combinedStories.length > 0) {
                  html += '<div class="search-modal__group">';
                  html += '<h3 class="search-modal__group-title">' + escapeHtml(storiesTitle) + '</h3>';
                  html += '<div class="search-modal__grid">';
                  combinedStories.slice(0, 4).forEach(function (s) {
                    html += '<a href="' + sanitizeUrl(s.url) + '" class="search-modal__page-link">' + escapeHtml(s.title) + ' &rarr;</a>';
                  });
                  html += '</div></div>';
                }

                html += '<div class="search-modal__footer-link">';
                html += '<a href="' + sanitizeUrl(searchUrl) + '?q=' + encodeURIComponent(query) + '" class="btn small">' + escapeHtml(viewAllText) + '</a>';
                html += '</div>';

                searchResults.innerHTML = html;
              })
              .catch(function (err) {
                if (err.name === 'AbortError') return;
                console.error('Predictive search error:', err);
              });
          }, 250);
        });
      }

      var mq = window.matchMedia('(min-width: 769px)');
      function onChange(e) {
        if (e.matches) setOpen(false);
      }
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else mq.addListener(onChange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        var header = document.querySelector('.header-editorial');
        if (header) initHeader(header);
      });
    } else {
      var header = document.querySelector('.header-editorial');
      if (header) initHeader(header);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('header-editorial-section') || event.target.querySelector('.header-editorial')) {
        var header = event.target.querySelector('.header-editorial') || event.target;
        initHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pattern-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPatternExplorer(section) {
      if (!section || section.dataset.patternInitialized) return;
      section.dataset.patternInitialized = 'true';

      var tabButtons = section.querySelectorAll('[data-tab-target]');
      var panels = section.querySelectorAll('[data-pattern-item]');

      function activateTab(blockId) {
        tabButtons.forEach(function (btn) {
          var isMatch = btn.getAttribute('data-tab-target') === blockId;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          btn.setAttribute('tabindex', isMatch ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          var isMatch = panel.getAttribute('data-block-id') === blockId;
          panel.classList.toggle('is-active', isMatch);
          panel.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
          if (isMatch) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      // Activate first item by default if none active
      var activePanel = section.querySelector('[data-pattern-item].is-active');
      if (!activePanel && panels.length > 0) {
        var firstId = panels[0].getAttribute('data-block-id');
        activateTab(firstId);
      } else if (activePanel) {
        activateTab(activePanel.getAttribute('data-block-id'));
      }

      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var blockId = btn.getAttribute('data-tab-target');
          activateTab(blockId);
        });
      });

      // Keyboard navigation on tabs (ArrowLeft, ArrowRight)
      var tabList = section.querySelector('[data-pattern-tabs]');
      if (tabList) {
        tabList.addEventListener('keydown', function (e) {
          if (!tabButtons || tabButtons.length === 0) return;
          var activeIndex = -1;
          for (var i = 0; i < tabButtons.length; i++) {
            if (tabButtons[i].classList.contains('is-active')) {
              activeIndex = i;
              break;
            }
          }
          if (activeIndex === -1) return;

          var nextIndex = activeIndex;
          if (e.key === 'ArrowRight') {
            nextIndex = (activeIndex + 1) % tabButtons.length;
          } else if (e.key === 'ArrowLeft') {
            nextIndex = (activeIndex - 1 + tabButtons.length) % tabButtons.length;
          } else if (e.key === 'Home') {
            nextIndex = 0;
          } else if (e.key === 'End') {
            nextIndex = tabButtons.length - 1;
          } else {
            return;
          }

          e.preventDefault();
          var targetBtn = tabButtons[nextIndex];
          targetBtn.focus();
          activateTab(targetBtn.getAttribute('data-tab-target'));
        });
      }

      // Shopify Theme Editor Sync
      document.addEventListener('shopify:block:select', function (event) {
        if (event.target && event.target.closest('.pattern-explorer')) {
          var blockId = event.detail.blockId;
          if (blockId) activateTab(blockId);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.pattern-explorer').forEach(initPatternExplorer);
      });
    } else {
      document.querySelectorAll('.pattern-explorer').forEach(initPatternExplorer);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var explorer = event.target.querySelector('.pattern-explorer') || event.target;
      if (explorer && explorer.classList.contains('pattern-explorer')) {
        initPatternExplorer(explorer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Lightbox & Size guide dialog elements & global state
    var lightbox = document.getElementById('ProductLightbox');
    var sizeGuide = document.getElementById('SizeGuideModal');
    var currentLightboxIdx = 0;
    var lastLightboxOpener = null;
    var lastSizeGuideOpener = null;

    function isFocusable(el) {
      if (!el || typeof el.focus !== 'function' || el === document.body) return false;
      if (!document.body.contains(el)) return false;
      if (el.disabled) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      var rects = el.getClientRects();
      if (!rects || rects.length === 0) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    function restoreLightboxFocus() {
      if (isFocusable(lastLightboxOpener)) {
        lastLightboxOpener.focus();
      } else {
        var fallback = document.querySelector('[data-zoom-trigger], .product-editorial__image-wrap button');
        if (isFocusable(fallback)) fallback.focus();
      }
      lastLightboxOpener = null;
    }

    function restoreSizeGuideFocus() {
      if (isFocusable(lastSizeGuideOpener)) {
        lastSizeGuideOpener.focus();
      } else {
        var fallback = document.querySelector('[data-size-guide-open]');
        if (isFocusable(fallback)) fallback.focus();
      }
      lastSizeGuideOpener = null;
    }

    function openLightbox(index, opener) {
      if (!lightbox) return;
      if (opener && isFocusable(opener)) {
        lastLightboxOpener = opener;
      } else if (!lastLightboxOpener && isFocusable(document.activeElement) && !lightbox.contains(document.activeElement)) {
        lastLightboxOpener = document.activeElement;
      }
      var slides = document.querySelectorAll('.product-editorial__image-wrap');
      if (slides.length > 0) {
        if (index < 0 || index >= slides.length) index = 0;
        currentLightboxIdx = index;
        var mediaContainer = lightbox.querySelector('[data-lightbox-media]');
        var targetImg = slides[index] ? slides[index].querySelector('img') : null;
        if (mediaContainer) {
          mediaContainer.textContent = '';
          if (targetImg) {
            var img = document.createElement('img');
            img.src = targetImg.currentSrc || targetImg.src || '';
            img.alt = targetImg.alt || '';
            mediaContainer.appendChild(img);
          }
        }
        var prevNav = lightbox.querySelector('[data-lightbox-prev]');
        var nextNav = lightbox.querySelector('[data-lightbox-next]');
        if (prevNav) prevNav.style.display = slides.length > 1 ? '' : 'none';
        if (nextNav) nextNav.style.display = slides.length > 1 ? '' : 'none';
      }
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
      document.documentElement.classList.add('menu-open');
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
        document.documentElement.classList.remove('menu-open');
        restoreLightboxFocus();
      }
    }

    function openSizeGuide(opener) {
      if (!sizeGuide) return;
      if (opener && isFocusable(opener)) {
        lastSizeGuideOpener = opener;
      } else if (isFocusable(document.activeElement) && !sizeGuide.contains(document.activeElement)) {
        lastSizeGuideOpener = document.activeElement;
      }
      if (typeof sizeGuide.showModal === 'function') {
        sizeGuide.showModal();
      } else {
        sizeGuide.setAttribute('open', '');
      }
      document.documentElement.classList.add('menu-open');
    }

    function closeSizeGuide() {
      if (!sizeGuide) return;
      if (typeof sizeGuide.close === 'function') {
        sizeGuide.close();
      } else {
        sizeGuide.removeAttribute('open');
        document.documentElement.classList.remove('menu-open');
        restoreSizeGuideFocus();
      }
    }

    if (lightbox && !lightbox.dataset.lightboxInitialized) {
      lightbox.dataset.lightboxInitialized = 'true';
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('product-lightbox__container') || e.target.closest('[data-lightbox-close]')) closeLightbox();
        if (e.target.closest('[data-lightbox-prev]')) {
          var slides = document.querySelectorAll('.product-editorial__image-wrap');
          if (slides.length > 0) {
            var prevIdx = (currentLightboxIdx - 1 + slides.length) % slides.length;
            openLightbox(prevIdx);
          }
        }
        if (e.target.closest('[data-lightbox-next]')) {
          var slides = document.querySelectorAll('.product-editorial__image-wrap');
          if (slides.length > 0) {
            var nextIdx = (currentLightboxIdx + 1) % slides.length;
            openLightbox(nextIdx);
          }
        }
      });
      lightbox.addEventListener('close', function () {
        document.documentElement.classList.remove('menu-open');
        restoreLightboxFocus();
      });
      lightbox.addEventListener('cancel', function () {
        document.documentElement.classList.remove('menu-open');
      });
    }

    if (sizeGuide && !sizeGuide.dataset.sizeGuideInitialized) {
      sizeGuide.dataset.sizeGuideInitialized = 'true';
      sizeGuide.addEventListener('click', function (e) {
        if (e.target === sizeGuide || e.target.closest('[data-size-guide-close]')) closeSizeGuide();
      });
      sizeGuide.addEventListener('close', function () {
        document.documentElement.classList.remove('menu-open');
        restoreSizeGuideFocus();
      });
      sizeGuide.addEventListener('cancel', function () {
        document.documentElement.classList.remove('menu-open');
      });
    }

    // Keyboard navigation: Left/Right arrows for lightbox zoom
    document.addEventListener('keydown', function (e) {
      if (lightbox && lightbox.open) {
        var slides = document.querySelectorAll('.product-editorial__image-wrap');
        if (slides.length > 0) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            var prevIdx = (currentLightboxIdx - 1 + slides.length) % slides.length;
            openLightbox(prevIdx);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            var nextIdx = (currentLightboxIdx + 1) % slides.length;
            openLightbox(nextIdx);
          }
        }
      }
    });

    // Delegated click handler for size guide trigger
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-size-guide-open]');
      if (trigger) {
        e.preventDefault();
        openSizeGuide(trigger);
      }
    });

    function initProductSection(root) {
      if (!root || root.dataset.productInitialized) return;
      root.dataset.productInitialized = 'true';

      // Mobile gallery elements
      var galleryTrack = root.querySelector('[data-gallery-track]');
      var counterEl = root.querySelector('[data-gallery-counter]');
      var prevBtn = root.querySelector('[data-gallery-prev]');
      var nextBtn = root.querySelector('[data-gallery-next]');
      var slides = root.querySelectorAll('.product-editorial__image-wrap');

      // Mobile swipe scroll-snap counter
      if (galleryTrack && counterEl && slides.length > 1) {
        var pad = function (num) { return (num < 10 ? '0' : '') + num; };
        galleryTrack.addEventListener('scroll', function () {
          var trackWidth = galleryTrack.offsetWidth || 1;
          var index = Math.round(galleryTrack.scrollLeft / trackWidth);
          var current = Math.min(Math.max(index + 1, 1), slides.length);
          counterEl.textContent = pad(current) + ' / ' + pad(slides.length);
        }, { passive: true });

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            var trackWidth = galleryTrack.offsetWidth || 300;
            galleryTrack.scrollBy({ left: -trackWidth, behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            var trackWidth = galleryTrack.offsetWidth || 300;
            galleryTrack.scrollBy({ left: trackWidth, behavior: 'smooth' });
          });
        }
      }

      root.querySelectorAll('[data-zoom-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-zoom-trigger'), 10) || 0;
          openLightbox(idx, btn);
        });
      });

      // Product Form and Variants
      var dataEl = root.querySelector('[data-product-variants]');
      var select = root.querySelector('[data-variant-select]');
      var form = root.querySelector('[data-product-form]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var button = root.querySelector('[data-add-to-cart]');
      var buttonText = root.querySelector('[data-add-to-cart-text]');
      var waitlist = root.querySelector('[data-waitlist]');
      var optionPills = root.querySelectorAll('[data-option-pill]');

      if (!dataEl || !button) return;

      // Sticky mobile add-to-cart bar
      var stickyBar = root.querySelector('[data-sticky-atc]');
      if (stickyBar && 'IntersectionObserver' in window) {
        var stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
        var stickyText = stickyBar.querySelector('[data-sticky-atc-text]');
        var stickyPrice = stickyBar.querySelector('[data-sticky-price]');

        var syncSticky = function () {
          if (stickyText && buttonText) stickyText.textContent = buttonText.textContent;
          if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
          if (stickyBtn) stickyBtn.disabled = button.disabled;
        };
        syncSticky();

        if ('MutationObserver' in window) {
          new MutationObserver(syncSticky).observe(button, { attributes: true, childList: true, subtree: true, characterData: true });
          if (priceEl) new MutationObserver(syncSticky).observe(priceEl, { childList: true, characterData: true, subtree: true });
        }

        stickyBar.removeAttribute('hidden');
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', scrolledPast);
        }).observe(button);

        if (stickyBtn) {
          stickyBtn.addEventListener('click', function () {
            if (!button.disabled) button.click();
          });
        }
      }

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      var qtyInput = root.querySelector('[data-qty-input]');
      var qtyMinus = root.querySelector('[data-qty-minus]');
      var qtyPlus = root.querySelector('[data-qty-plus]');
      var lowStockEl = root.querySelector('[data-low-stock]');
      var currentMax = null;

      function clampQty() {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (currentMax !== null && currentMax > 0 && n > currentMax) n = currentMax;
        qtyInput.value = n;
        if (qtyMinus) qtyMinus.disabled = n <= 1;
        if (qtyPlus) qtyPlus.disabled = currentMax !== null && n >= currentMax;
      }

      function applyInventory(variant) {
        var qty = variant && typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
        currentMax = qty !== null && qty > 0 ? qty : null;
        clampQty();
        if (!lowStockEl) return;
        var threshold = parseInt(lowStockEl.getAttribute('data-threshold'), 10) || 0;
        if (variant && variant.available && qty !== null && qty > 0 && threshold > 0 && qty <= threshold) {
          lowStockEl.textContent = (lowStockEl.getAttribute('data-label') || '').replace('__COUNT__', qty);
          lowStockEl.removeAttribute('hidden');
        } else {
          lowStockEl.textContent = '';
          lowStockEl.setAttribute('hidden', '');
        }
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', clampQty);
        if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; clampQty(); });
        if (qtyPlus) qtyPlus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; clampQty(); });
      }

      // Keep sold-out option values visible but clearly marked (never hidden)
      function refreshPillAvailability() {
        var selected = getSelectedOptions();
        var labelTpl = button.getAttribute('data-label-unavailable-option') || '';
        optionPills.forEach(function (pill) {
          var idx = parseInt(pill.getAttribute('data-option-index'), 10);
          var val = pill.getAttribute('data-value');
          var purchasable = variants.some(function (v) {
            if (!v.available || v.options[idx] !== val) return false;
            return v.options.every(function (o, i) {
              return i === idx || selected[i] === undefined || o === selected[i];
            });
          });
          pill.classList.toggle('is-unavailable', !purchasable);
          if (purchasable) {
            pill.removeAttribute('aria-label');
          } else {
            pill.setAttribute('aria-label', labelTpl.replace('__VALUE__', val));
          }
        });
      }

      var waitlistAlwaysShow = waitlist && waitlist.getAttribute('data-always-show') === 'true';

      function getSelectedOptions() {
        var selected = [];
        var groups = root.querySelectorAll('[data-option-group]');
        groups.forEach(function (group) {
          var activePill = group.querySelector('[data-option-pill].is-selected');
          if (activePill) {
            selected.push(activePill.getAttribute('data-value'));
          }
        });
        return selected;
      }

      function findVariantByOptions(selectedOptions) {
        return variants.find(function (variant) {
          return variant.options.every(function (optVal, idx) {
            return optVal === selectedOptions[idx];
          });
        });
      }

      function updateWaitlist(available) {
        if (!waitlist || waitlistAlwaysShow) return;
        if (available) {
          waitlist.setAttribute('hidden', '');
        } else {
          waitlist.removeAttribute('hidden');
        }
      }

      function update(variant) {
        if (!variant) {
          button.disabled = true;
          if (buttonText) {
            buttonText.textContent = button.getAttribute('data-label-unavailable') || 'Unavailable';
          }
          if (waitlist && !waitlistAlwaysShow) {
            waitlist.setAttribute('hidden', '');
          }
          return;
        }

        if (select) select.value = variant.id;

        if (window.history && window.history.replaceState) {
          try {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set('variant', variant.id);
            var newUrl = window.location.pathname + '?' + searchParams.toString();
            window.history.replaceState({ path: newUrl }, '', newUrl);
          } catch (e) {
            var fallbackUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({ path: fallbackUrl }, '', fallbackUrl);
          }
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          if (variant.on_sale) {
            compareEl.textContent = variant.compare_at_price;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }

        button.disabled = !variant.available;
        if (buttonText) {
          buttonText.textContent = variant.available
            ? button.getAttribute('data-label-add')
            : button.getAttribute('data-label-soldout');
        }

        if (variant.featured_media_id) {
          var mediaWrap = document.getElementById('ProductImage-' + variant.featured_media_id);
          if (mediaWrap) {
            if (window.innerWidth >= 968) {
              mediaWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } else if (galleryTrack) {
              galleryTrack.scrollTo({ left: mediaWrap.offsetLeft, behavior: 'smooth' });
            }
          }
        }

        updateWaitlist(variant.available);
        applyInventory(variant);
      }

      optionPills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var group = pill.closest('[data-option-group]');
          if (!group) return;

          group.querySelectorAll('[data-option-pill]').forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-pressed', 'true');

          var valueLabel = group.querySelector('[data-option-value]');
          if (valueLabel) valueLabel.textContent = pill.getAttribute('data-value');

          var selectedOptions = getSelectedOptions();
          var matchedVariant = findVariantByOptions(selectedOptions);
          update(matchedVariant);
          refreshPillAvailability();
        });
      });

      refreshPillAvailability();
      applyInventory(variants.find(function (v) { return select && String(v.id) === String(select.value); }));

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (button.disabled) return;

          var originalText = buttonText ? buttonText.textContent : '';
          if (buttonText) buttonText.textContent = button.getAttribute('data-label-adding');
          button.disabled = true;

          var formData = new FormData(form);
          formData.append('sections', 'cart-drawer');

          var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

          fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (errJson) {
                  throw new Error(errJson.description || errJson.message || 'Error adding to cart');
                });
              }
              return res.json();
            })
            .then(function (data) {
              if (buttonText) buttonText.textContent = button.getAttribute('data-label-added') || originalText;
              button.disabled = false;
              setTimeout(function () {
                if (buttonText && !button.disabled) buttonText.textContent = originalText;
              }, 1500);

              if (data && data.sections && data.sections['cart-drawer'] && typeof window.applyCartDrawerSection === 'function') {
                window.applyCartDrawerSection(data.sections['cart-drawer']);
                if (typeof window.refreshCartDrawer === 'function') {
                  window.refreshCartDrawer(true).then(function () {
                    if (typeof window.openCartDrawer === 'function') window.openCartDrawer(button);
                  });
                } else if (typeof window.openCartDrawer === 'function') {
                  window.openCartDrawer(button);
                }
              } else if (typeof window.refreshCartDrawer === 'function') {
                window.refreshCartDrawer().then(function () {
                  if (typeof window.openCartDrawer === 'function') window.openCartDrawer(button);
                });
              } else if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer(button);
              }
            })
            .catch(function (err) {
              console.error('Error adding to cart:', err);
              if (buttonText) buttonText.textContent = originalText;
              button.disabled = false;
              alert(err.message || 'Error adding piece to cart');
            });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.product-editorial').forEach(initProductSection);
      });
    } else {
      document.querySelectorAll('.product-editorial').forEach(initProductSection);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var productSection = event.target.querySelector('.product-editorial') || event.target;
      if (productSection && productSection.classList.contains('product-editorial')) {
        initProductSection(productSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
